// import { StrictMode } from 'react'
// import { createRoot } from 'react-dom/client'
// import './index.css'
// import RoutesComponent from './Routes'
// import { Provider } from 'react-redux'
// import { store } from './store/Store'
// import GlobalLoader from './Reducers/GlobalLoader'
// createRoot(document.getElementById('root')).render(
//   <StrictMode>
//     <Provider store={store}>
//       <GlobalLoader />
//       <RoutesComponent />
//     </Provider>
//   </StrictMode>,
// )


import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";

import "./index.css";
import { store } from "./store/Store";
import GlobalLoader from "./Reducers/GlobalLoader";
import App from "./App";
import ScrollToTop from "./LoginComponents/ScrollToTop";

createRoot(document.getElementById("root")).render(
  // <StrictMode>
  <Provider store={store}>
    <BrowserRouter>
      <GlobalLoader />
      <ScrollToTop />
      <App />
    </BrowserRouter>
  </Provider>
  // </StrictMode>
);